function vehicleSearch() {
    const _sec = (window.cgLang && window.cgLang.secciones) || {};
    const _val = (window.cgLang && window.cgLang.validacion) || {};
    const _err = (window.cgLang && window.cgLang.errores) || {};

    return {
        searchTerm: "",
        showResults: false,
        showNoResults: false,
        showConsultaCard: true,
        displayedSearchTerm: "",
        _toggleTimeout: null,
        isLoading: false,

        // Función de inicialización
        init() {
            // Leer parámetro de la URL
            const urlParams = new URLSearchParams(window.location.search);
            const placaParam = urlParams.get("placa");

            if (placaParam) {
                this.searchTerm = placaParam.trim();
                this.buscarVehiculo();
                // [LOG] // console.log("🔗 Parámetro de placa detectado:", placaParam);
            }

            const input = document.getElementById("search");
            if (input) {
                input.style.textTransform = "uppercase";
                input.autocomplete = "off";
                input.autocorrect = "off";
                input.autocapitalize = "off";
                input.spellcheck = false;

                input.addEventListener("focus", function () {
                    this.setAttribute("autocomplete", "new-password");
                    setTimeout(() => {
                        this.setAttribute("autocomplete", "off");
                    }, 100);
                });
            }
        },

        watch: {
            searchTerm(newValue) {
                this.searchTerm = newValue.toUpperCase();
            },
        },

        openSections: {
            datosVehiculo: false,
            deudas: false,
            comparendos: false,
            estadoinmovilizacion: false,
            medidasCautelares: false,
            notificaciones: false,
        },

        accordionStructure: {
            datosVehiculo: {
                titulo: (_sec.datosVehiculo && _sec.datosVehiculo.titulo) || "Datos del vehículo",
                informacion: (_sec.datosVehiculo && _sec.datosVehiculo.informacion) || "Información técnica y legal del vehículo",
                descripcion: "1",
                icon: (_sec.datosVehiculo && _sec.datosVehiculo.icono) || "directions_car",
                indicator_class: (_sec.datosVehiculo && _sec.datosVehiculo.clase_indicador) || "primary",
            },
            deudas: {
                titulo: (_sec.deudas && _sec.deudas.titulo) || "Deudas",
                informacion: (_sec.deudas && _sec.deudas.informacion) || "Multas y sanciones pendientes de pago",
                descripcion: "0",
                icon: (_sec.deudas && _sec.deudas.icono) || "gavel",
                indicator_class: (_sec.deudas && _sec.deudas.clase_indicador) || "warning",
            },
            comparendos: {
                titulo: (_sec.comparendos && _sec.comparendos.titulo) || "Comparendos registrados",
                informacion: (_sec.comparendos && _sec.comparendos.informacion) || "Historial de infracciones de tránsito",
                descripcion: "0",
                icon: (_sec.comparendos && _sec.comparendos.icono) || "assignment",
                indicator_class: (_sec.comparendos && _sec.comparendos.clase_indicador) || "secondary",
            },
            estadoinmovilizacion: {
                titulo: (_sec.estadoinmovilizacion && _sec.estadoinmovilizacion.titulo) || "Estado de inmovilización",
                informacion: (_sec.estadoinmovilizacion && _sec.estadoinmovilizacion.informacion) || "Información sobre retención vehicular",
                descripcion: "0",
                icon: "local_parking",
                indicator_class: "accent",
            },
            medidasCautelares: {
                titulo: (_sec.medidasCautelares && _sec.medidasCautelares.titulo) || "Medidas cautelares",
                informacion: (_sec.medidasCautelares && _sec.medidasCautelares.informacion) || "Restricciones legales del vehículo",
                descripcion: "0",
                icon: (_sec.medidasCautelares && _sec.medidasCautelares.icono) || "security",
                indicator_class: (_sec.medidasCautelares && _sec.medidasCautelares.clase_indicador) || "error",
            },
            notificaciones: {
                titulo: (_sec.notificaciones && _sec.notificaciones.titulo) || "Notificaciones",
                informacion: (_sec.notificaciones && _sec.notificaciones.informacion) || "Comunicaciones oficiales",
                descripcion: "0",
                icon: (_sec.notificaciones && _sec.notificaciones.icono) || "notifications",
                indicator_class: (_sec.notificaciones && _sec.notificaciones.clase_indicador) || "info",
            },
        },

        responseData: {
            datosVehiculo: [],
            deudas: [],
            comparendos: [],
            estadoinmovilizacion: [],
            medidasCautelares: [],
            notificaciones: [],
        },
        buscarVehiculo() {
            // [LOG] // console.log("🔍 Función buscarVehiculo llamada");
            // [LOG] // console.log("🔍 Término de búsqueda:", this.searchTerm);

            if (this.searchTerm.trim() === "") {
                if (window.showAlert) {
                    showAlert({
                        type: 'warning',
                        title: _val.ingrese_placa || 'Por favor ingrese una placa o número de identificación',
                        showConfirmButton: true,
                        timer: null,
                        confirmButtonText: 'Entendido',
                    });
                } else {
                    alert(_val.ingrese_placa || "Por favor ingrese una placa o número de identificación");
                }
                return;
            }

            this.isLoading = true;

            this.displayedSearchTerm = this.searchTerm.toUpperCase().trim();
            this.showConsultaCard = false;

            fetch("/servicios/consulta-general", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": document
                        .querySelector('meta[name="csrf-token"]')
                        .getAttribute("content"),
                },
                body: JSON.stringify({ placa: this.searchTerm }),
            })
                .then((response) => response.json())
                .then((data) => {
                    this.isLoading = false;
                    // [LOG] // console.log("📊 Datos recibidos:", data);

                    this.responseData = {
                        datosVehiculo: Array.isArray(data.datosVehiculo)
                            ? data.datosVehiculo
                            : [],
                        deudas: Array.isArray(data.deudaTransito)
                            ? data.deudaTransito
                            : [],
                        comparendos: Array.isArray(data.comparendos)
                            ? data.comparendos
                            : [],
                        estadoinmovilizacion: Array.isArray(data.inmovilizados)
                            ? data.inmovilizados
                            : [],
                        medidasCautelares: Array.isArray(data.medidasCautelares)
                            ? data.medidasCautelares
                            : [],
                        notificaciones: Array.isArray(data.notificaciones)
                            ? data.notificaciones
                            : [],
                    };

                    this.accordionStructure.datosVehiculo.descripcion = String(
                        this.responseData.datosVehiculo.length
                    );
                    this.accordionStructure.deudas.descripcion = String(
                        this.responseData.deudas.length
                    );
                    this.accordionStructure.comparendos.descripcion = String(
                        this.responseData.comparendos.length
                    );
                    this.accordionStructure.estadoinmovilizacion.descripcion =
                        String(this.responseData.estadoinmovilizacion.length);
                    this.accordionStructure.medidasCautelares.descripcion =
                        String(this.responseData.medidasCautelares.length);
                    this.accordionStructure.notificaciones.descripcion = String(
                        this.responseData.notificaciones.length
                    );

                    const hasVehiculo =
                        this.responseData.datosVehiculo.length > 0;
                    const hasDeudas = this.responseData.deudas.length > 0;
                    const hasComparendos =
                        this.responseData.comparendos.length > 0;
                    const hasInmovilizados =
                        this.responseData.estadoinmovilizacion.length > 0;
                    const hasMedidas =
                        this.responseData.medidasCautelares.length > 0;
                    const hasNotificaciones =
                        this.responseData.notificaciones.length > 0;

                    if (
                        hasVehiculo ||
                        hasDeudas ||
                        hasComparendos ||
                        hasInmovilizados ||
                        hasMedidas ||
                        hasNotificaciones
                    ) {
                        this.showResults = true;
                        this.showNoResults = false;
                        this.openSections = {
                            datosVehiculo: hasVehiculo,
                            deudas: hasDeudas,
                            comparendos: hasComparendos,
                            estadoinmovilizacion: hasInmovilizados,
                            medidasCautelares: hasMedidas,
                            notificaciones: hasNotificaciones,
                        };
                        // [LOG] // console.log(
                        // [LOG] //     "✅ Resultados encontrados y mostrados para:",
                        // [LOG] //     this.displayedSearchTerm
                        // [LOG] // );
                    } else {
                        this.showResults = true;
                        this.showNoResults = true;
                        this.openSections = {};
                        // [LOG] // console.log(
                        // [LOG] //     "❌ No se encontraron resultados para:",
                        // [LOG] //     this.displayedSearchTerm
                        // [LOG] // );
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    // [LOG] // console.error("Error en consulta AJAX:", error);

                    if (error.name === "NetworkError") {
                        if (window.showAlert) {
                            showAlert({
                                type: 'error',
                                title: 'Sin conexión',
                                text: _err.conexion || 'Error de conexión. Por favor, verifique su conexión a internet.',
                                showConfirmButton: true,
                                timer: null,
                                confirmButtonText: 'Entendido',
                            });
                        } else {
                            alert(_err.conexion || "Error de conexión. Por favor, verifique su conexión a internet.");
                        }
                    } else {
                        if (window.showAlert) {
                            showAlert({
                                type: 'error',
                                title: 'Error al consultar',
                                text: _err.general || 'Error al consultar los datos. Por favor, inténtelo de nuevo.',
                                showConfirmButton: true,
                                timer: null,
                                confirmButtonText: 'Entendido',
                            });
                        } else {
                            alert(_err.general || "Error al consultar los datos. Por favor, inténtelo de nuevo.");
                        }
                    }

                    this.showResults = true;
                    this.showNoResults = true;
                    this.openSections = {};
                });
        },

        toggleSection(sectionKey) {
            // [LOG] // console.log("🔥 Toggle section called:", sectionKey);
            // [LOG] // console.log("🔥 Current state:", this.openSections[sectionKey]);

            if (this._toggleTimeout) {
                clearTimeout(this._toggleTimeout);
            }

            this._toggleTimeout = setTimeout(() => {
                const newOpenSections = {
                    ...this.openSections,
                };
                newOpenSections[sectionKey] = !newOpenSections[sectionKey];
                this.openSections = newOpenSections;

                // [LOG] // console.log("🔥 New state:", this.openSections[sectionKey]);
                // [LOG] // console.log("🔥 All open sections after:", this.openSections);
            }, 100);
        },

        resetSearch() {
            this.searchTerm = "";
            this.displayedSearchTerm = "";
            this.showResults = false;
            this.showNoResults = false;
            this.showConsultaCard = true;
            this.openSections = {};

            this.responseData = {
                datosVehiculo: [],
                deudas: [],
                comparendos: [],
                estadoinmovilizacion: [],
                medidasCautelares: [],
                notificaciones: [],
            };

            Object.keys(this.accordionStructure).forEach((key) => {
                this.accordionStructure[key].descripcion = "0";
            });

            // [LOG] // console.log("🔄 Búsqueda reseteada");
        },

        formatFecha(fecha) {
            if (!fecha) return "";
            const date = new Date(fecha);
            if (isNaN(date)) return fecha;
            const dia = String(date.getDate()).padStart(2, "0");
            const mes = date
                .toLocaleString("es-CO", { month: "short" })
                .replace(".", "");
            const anio = date.getFullYear();
            return `${dia}-${mes}-${anio}`;
        },
        formatValor(valor) {
            if (!valor) return "0";
            return Number(valor).toLocaleString("es-CO");
        },

        maskData(value, visibleCount = 4) {
            if (!value || value.length <= visibleCount) return value;
            const masked = "●".repeat(value.length - visibleCount);
            const visible = value.slice(-visibleCount);
            return masked + visible;
        },
    };
}

window.vehicleSearch = vehicleSearch;
